import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import $ from "jquery";
const RawMaterialPricingEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  //const [valueContents, setValueContents] = useState([]);
  const [permission, setPermission] = useState({});
  const [trasnportList, setTrasnportList] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);

 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
  const [currencySymbol, setCurrencySymbol] = useState('dh');

  const [cabranesList, setCabranesList] = useState([]);
   let season_id = localStorage.getItem("season_id");

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const formik = useFormik({
    initialValues: {
      id: value.id,
      season_id:season_id,
      currency: value.currency,
      price: value.price,
      decay_price: value.decay_price,
      rebate: value.rebate,
      workers_cost: value.workers_cost,
      transport_cost: value.transport_cost,
      transport:value.transport,
      cabrane: value.cabrane,
      payment_from: value.payment_from,
      cost_paid_by_farmer:value.cost_paid_by_farmer,
      origin:value.origin,
      //palletesation: valueContents,
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values,  { setSubmitting }) => {
      axios
        .post("/raw-materials/update-pricing", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update Raw Materials Pricing");
          delete backendErrors['error'];
          // actions.setSubmitting(false);
          setSubmitting(false);
           if (response.data.code === 200) {
            //  setBackendSuccess(response.data.message);
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/raw-material-pricing";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(191)); 
         axios.post("/rawmaterials-cabranes/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`,  Apitoken: Apitoken,},  } )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.cabranes;
          let supplierslist = suppliers.map((cat, index) => ({
            label: cat.name,
            value: cat.id,
            key: `cabrane-${index}`,
          }));
          setCabranesList(supplierslist);
        } else {
          console.log("API response is not an array");
        }
      })  .catch((error) => {
        console.log(error);
      });
      axios.post("/rawmaterials-transports/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`,  Apitoken: Apitoken,},  } )
        .then((response) => {
          if (response.data.code === 200) {
            let suppliers = response.data.data.transports;
            let supplierslist = suppliers.map((cat, index) => ({
              label: cat.driver_name + ' ('+cat.plate_number+')' ,
              value: cat.id,
              key: `cabrane-${index}`,
            }));
            setTrasnportList(supplierslist);
          } else {
            console.log("API response is not an array");
          }
        })  .catch((error) => {
          console.log(error);
        });




    
    axios
      .get(`/raw-materials/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
            setValue(response.data.data.raw);
          
          const currencydetail = primaryCurrency.find(item => item.value === response.data.data.raw.currency) || null;
           setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');
        }
      })
      .catch((error) => {
        console.log(error);
      });
 

   
  
  }, [id]);
// let raw_data_invoice ='';


  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const customFuction = (event) =>{
    // var index = event.target.selectedIndex;
    // var optionElement = event.target.childNodes[index];
    // var key_sybmol =  optionElement.getAttribute('key_sybmol');
    console.log(event);
    setCurrencySymbol(event.symbol);
  
  }
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Pricing</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-material-pricing">Raw Material Pricing</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
                {permission && permission.update == 1 && (
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                          <div className="row">

                          <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Lot Number </h6>
                                    <p>{value.lot_number}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Date & time</h6>
                                    <p>{value.date_time}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Shift Date</h6>
                                    <p>{value.shift_date}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Plate Number</h6>
                                    <p>{value.plate_number}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Farmer Name</h6>
                                    <p>{value.farmer_detail ? value.farmer_detail.name : ""}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                      
                            
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Location</h6>
                                    <p>{value.location_name ? value.location_name.title : ""}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Supplier</h6>
                                    <p>{value.supplier_name ? value.supplier_name.name : ""}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                           <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Driver name</h6>
                                    <p>{value.driver_name}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>BL Net Weight</h6>
                                    <p>{value.net_weight}KG</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>BL Gross Weight</h6>
                                    <p>{value.gross_weight}KG</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                         
                              
                            {/* <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                  <div className="customer-details-cont">
                                    <h6>Incoming Status</h6>
                                    <p>{value.incoming_status
                                ? value.incoming_status_title.title
                                : ""}</p>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                              
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                              <div className="customer-details  m-3">
                                <div className="d-flex align-items-center">
                                <div className="customer-details-cont">
                                    <h6>Decay Net Weight</h6>
                                     <p>{value.raw_material_decay_net_weight}KG</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            {permission && permission.update == 1 && (
              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <h4 className="card-title">Raw Material Pricing </h4>
                              <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group status2">
                                      <label>Select Currency</label>
                                      <Select

                                          className="w-100"
                                          value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                          name="currency"
                                          onChange={(selectedOption) => {
                                          handleSelectChange("currency", selectedOption);
                                          customFuction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={primaryCurrency}
                                          placeholder="Select"

                                        />
                                     
                                      <small>
                                        {backendErrors.currency && (
                                            <span className="form-error mt-1">
                                              {backendErrors.currency}
                                            </span>
                                          )}
                                      </small>
                                      </div>
                                    
                                    </div>
                                    <div className="col-md-3">
                                    <div className="form-group">
                                      <label>Price</label>
                                      <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                              event.preventDefault();
                                            }
                                          }}
                                          name="price"
                                          value={formik.values.price}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                            onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Net Weight" aria-label="Net Weight" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                          </div>
                                      </div>
                                      <small>
                                        {backendErrors.price && (
                                            <span className="form-error mt-1">
                                              {backendErrors.price}
                                            </span>
                                          )}
                                      </small>
                                      </div>

                                      </div>
                                      
                                    

                                  <div className="col-md-3">

                              
                                    <div className="form-group">
                                      <label>Decay Price</label>
                                    
                                      <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                              event.preventDefault();
                                            }
                                          }}
                                          name="decay_price"
                                          value={formik.values.decay_price}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                            onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Net Weight" aria-label="Net Weight" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                          </div>
                                      </div>
                                      <small>
                                        {backendErrors.decay_price && (
                                            <span className="form-error mt-1">
                                              {backendErrors.decay_price}
                                            </span>
                                          )}
                                      </small>
                                    </div>
                                    </div>
                                      
                                      <div className="col-md-3">
                                  
                                    <div className="form-group">
                                      <label>Rebate</label>
                                        <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                              event.preventDefault();
                                            }
                                          }}
                                          name="rebate"
                                          value={formik.values.rebate}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                            onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Rebate" aria-label="Rebate" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">%</span>
                                          </div>
                                      </div>


                                      <small>
                                        {backendErrors.rebate && (
                                            <span className="form-error mt-1">
                                              {backendErrors.rebate}
                                            </span>
                                          )}
                                      </small>
                                    </div>

                                  
                                  </div>
                                </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <h4 className="card-title">Add Workers Section: </h4>
                              <div className="row">
                                
                                      <div className="col-md-3">
                                      <div className="form-group">
                                        <label>Worker Cost</label>
                                      
                                        <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                              event.preventDefault();
                                            }
                                          }}
                                          name="workers_cost"
                                          value={formik.values.workers_cost}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                            onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Worker Cost" aria-label="Worker Cost" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                          </div>
                                      </div>
                                        <small>
                                          {backendErrors.workers_cost && (
                                              <span className="form-error mt-1">
                                                {backendErrors.workers_cost}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                      
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label>Cost Paid by Farmer</label>
                                      
                                        <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                              event.preventDefault();
                                            }
                                          }}
                                          name="cost_paid_by_farmer"
                                          value={formik.values.cost_paid_by_farmer}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                            onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Worker Cost" aria-label="Worker Cost" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                          </div>
                                      </div>
                                        <small>
                                          {backendErrors.cost_paid_by_farmer && (
                                              <span className="form-error mt-1">
                                                {backendErrors.cost_paid_by_farmer}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                      

                                  <div className="col-md-3">
                                  <div className="form-group ">
                                        <label>Select Cabrane</label>
                                        {cabranesList.length > 0 && (
                                          <Select

                                          className="w-100"
                                          value={cabranesList.find(option => option.value == formik.values.cabrane) || null} // Ensure correct format
                                          name="cabrane"
                                          onChange={(selectedOption) => {
                                          handleSelectChange("cabrane", selectedOption);
                                          //generateLotNumberLocation(selectedOption.value);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={cabranesList}
                                          placeholder="Select"

                                          
                                          // className="w-100"
                                          // data={cabranesList}
                                          // value={formik.values.cabrane}
                                          // name="cabrane"
                                          // onChange={(e) => {
                                          //   formik.handleChange(e);
                                          //   customHandleInput(e);
                                          // }} 
                                          // onBlur={formik.handleBlur}
                                          // options={{
                                          //   placeholder: "Select Cabrane",
                                          // }}
                                        />
                                        )}
                                        <small>
                                          {backendErrors.cabrane  && (
                                            <span className="form-error mt-1">
                                              {backendErrors.cabrane }
                                            </span>
                                          )}
                                        </small>
                                      </div>
                              
                                    
                                    </div>
                                   

                                    
                                </div>

                        
                          </div>
                        </div>
                      </div>
                    </div>
            
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <h4 className="card-title">Add Transport Section: </h4>
                              <div className="row">

                              <div className="col-md-3">
                                  <div className="form-group ">
                                        <label>Select Transport</label>
                                        {trasnportList.length > 0 && (
                                          <Select
                                              className="w-100"
                                              value={trasnportList.find(option => option.value == formik.values.transport) || null} // Ensure correct format
                                              name="transport"
                                              onChange={(selectedOption) => {
                                              handleSelectChange("transport", selectedOption);
                                              //generateLotNumberLocation(selectedOption.value);
                                              }}
                                              onBlur={formik.handleBlur}
                                              options={trasnportList}
                                              placeholder="transport"

                                          // className="w-100"
                                          // data={trasnportList}
                                          // value={formik.values.transport}
                                          // name="transport"
                                          // onChange={(e) => {
                                          //   formik.handleChange(e);
                                          //   customHandleInput(e);
                                          // }} 
                                          // onBlur={formik.handleBlur}
                                          // options={{
                                          //   placeholder: "Select Transport",
                                          // }}
                                        />
                                        )}
                                        <small>
                                          {backendErrors.transport  && (
                                            <span className="form-error mt-1">
                                              {backendErrors.transport }
                                            </span>
                                          )}
                                        </small>
                                      </div>
                              
                                    
                                    </div>


                              <div className="col-md-3">
                                  
                                  <div className="form-group">
                                    <label>Transport Cost</label>
                                  
                                    <div className="input-group">
                                        <input 
                                        type="text"
                                        onKeyPress={(event) => {
                                          // Allow only numbers (0-9)
                                          if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                            event.preventDefault();
                                          }
                                        }}
                                        name="transport_cost"
                                        value={formik.values.transport_cost}
                                        onChange={(e) => {
                                          formik.handleChange(e);
                                          customHandleInput(e);
                                        }}
                                          onBlur={formik.handleBlur}
                                        className="form-control" placeholder="Net Weight" aria-label="Net Weight" aria-describedby="basic-addon2" />
                                        <div className="input-group-append">
                                            <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                        </div>
                                    </div>
                                    <small>
                                      {backendErrors.transport_cost && (
                                          <span className="form-error mt-1">
                                            {backendErrors.transport_cost}
                                          </span>
                                        )}
                                    </small>
                                  </div>
                                  </div>

                                

                              <div className="col-md-6">
                                  
                                  <div className="form-group">
                                    <label>Origin</label>
                                  
                                    <div className="input-group">
                                        <input type="text" 
                                        name="origin"
                                        value={formik.values.origin}
                                        onChange={(e) => {
                                          formik.handleChange(e);
                                          customHandleInput(e);
                                        }}
                                          onBlur={formik.handleBlur}
                                        className="form-control" placeholder="Origin"  />
                                      
                                    </div>
                                    <small>
                                      {backendErrors.origin && (
                                          <span className="form-error mt-1">
                                            {backendErrors.origin}
                                          </span>
                                        )}
                                    </small>
                                  </div>
                                  </div>    
                                </div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
            
            
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                              <div className="text-end mt-4">
                                <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                                Update Raw Materials Pricing
                                </button>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
            
            
                </form>
              </FormikProvider>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default RawMaterialPricingEdit;
